import api from './api';

export interface RemitoVentaDetalleDto {
  nroIdformulario: number;
  nroItem: number;
  codigoArticulo?: string;
  descripcionArticulo?: string;
  cantidad?: number;
  precioUnitario?: number;
  descuento?: number;
  subtotal?: number;
  notas?: string;
}

export interface RemitoVenta {
  nroFormulario: number;
  nroRemito?: string;
  letra?: string;
  nroSuc: number;
  nroComprobante?: number;
  fechaEmision?: string | Date;
  horaEmision?: string | Date;
  nroTipoFormulario?: string;
  tipoCliente?: string;
  nroCliente?: number;
  nombre?: string;
  nroVendedor?: number;
  nroLista?: string;
  codigoMoneda?: number;
  importeTotal?: number;
  asentado?: string;
  descripcion?: string;
  usuario?: string;
  porcDesc?: number;
  porcDesc2?: number;
  porcDesc3?: number;
  nroUbicacionOrigen?: number;
  detalles?: RemitoVentaDetalleDto[];
}

export interface RemitoVentaFormularioDto {
  descripcion?: string;
  nroSuc?: number;
  fechaEmision?: string | Date;
  horaEmision?: string | Date;
  fechaVencim?: string | Date;
  nroCliente: number;
  nombre?: string;
  cuit?: string;
  nroLista?: string;
  nroUbicacionOrigen?: number;
  direccionEnvio?: string;
  codigoCiudadEnvio?: number;
  formaEntrega?: string;
  porcDesc?: number;
  porcDesc2?: number;
  porcDesc3?: number;
  nroFormularioFactura?: number;
}

export interface RemitoVentaCreateItemDto {
  codigoArticulo: string;
  descripcion?: string;
  cantidad: number;
  precioUnitario: number;
  porcDesc?: number;
  notas?: string;
  um?: string;
  codigoMoneda?: number;
  cotizacion?: number;
}

export interface RemitoVentaCreateDto {
  formulario: RemitoVentaFormularioDto;
  items: RemitoVentaCreateItemDto[];
}

export interface RemitoVentaSearchParams {
  searchTerm?: string;
  pageNumber: number;
  pageSize: number;
  fechaDesde?: Date;
  fechaHasta?: Date;
  nroCliente?: string;
  nroVendedor?: string;
  asentado?: string;
  nroSuc?: number;
}

export interface RemitoVentaPagedResult {
  items: RemitoVenta[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

const remitoVentaService = {
  getRemitosVenta: async (params: RemitoVentaSearchParams): Promise<RemitoVentaPagedResult> => {
    const queryParams: Record<string, unknown> = {
      PageNumber: params.pageNumber,
      PageSize: params.pageSize,
      SearchTerm: params.searchTerm || undefined,
    };
    if (params.fechaDesde) {
      queryParams.FechaDesde = params.fechaDesde.toISOString().split('T')[0];
    }
    if (params.fechaHasta) {
      queryParams.FechaHasta = params.fechaHasta.toISOString().split('T')[0];
    }
    if (params.nroCliente) {
      queryParams.NroCliente = params.nroCliente;
    }
    if (params.nroVendedor) {
      queryParams.NroVendedor = params.nroVendedor;
    }
    if (params.asentado) {
      queryParams.Asentado = params.asentado;
    }
    if (params.nroSuc != null) {
      queryParams.NroSuc = params.nroSuc;
    }
    const response = await api.get<RemitoVentaPagedResult>('/api/RemitosVenta', {
      params: queryParams,
    });
    return response.data;
  },

  getRemitoVenta: async (id: number): Promise<RemitoVenta> => {
    const response = await api.get<RemitoVenta>(`/api/RemitosVenta/${id}`);
    return response.data;
  },

  createRemitoVenta: async (payload: RemitoVentaCreateDto): Promise<RemitoVenta> => {
    const response = await api.post<RemitoVenta>('/api/RemitosVenta', payload);
    return response.data;
  },
};

export default remitoVentaService;
